import { useEffect, useState } from "react";
import { RefundPolicyAction } from "./APIs/action/index";
import { Box, Typography } from "@mui/material";
import useContentProtection from "../Common/useContentProtection";

const RefundPolicy = ({ inModal = false })  => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);
  const { onContextMenu, protectionSx } = useContentProtection();

  useEffect(() => {
    const getRefundPolicy = async () => {
        setLoading(true);
        const data = await RefundPolicyAction();
        setPolicy(data);
        setLoading(false);
    };
    getRefundPolicy();
  }, []);
  if (!policy) return null;
  return (
    <Box onContextMenu={onContextMenu} sx={{ p: 2, display: 'flex', gap: 2, flexDirection: 'column', ...protectionSx }}>
      {!inModal && <Typography variant="h1">{policy?.title}</Typography>}
      {(policy.description)
        ? (
          <Box component="ol" sx={{ m: 0, pl: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
            {policy.description.map((para, idx) => (
              <Box component="li" key={idx}>
                <Typography variant="body1">{para}</Typography>
              </Box>
            ))}
          </Box>
        )
        : <Typography variant="body1">{policy.description}</Typography>
      }
    </Box>
  );
};

export default RefundPolicy;